// extracted by mini-css-extract-plugin
export default {"container":"style_container__bGXec","logoSection":"style_logoSection__f1Hsa","title":"style_title__eupee","subName":"style_subName__BTR-I"};